import { render, staticRenderFns } from "./WeddingDate.vue?vue&type=template&id=d9b8c3dc&"
import script from "./WeddingDate.vue?vue&type=script&lang=js&"
export * from "./WeddingDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports